import axios from "axios";
import Cookies from "js-cookie";

// ---------------------------------------------------------------------------
// KNOWN INCONSISTENCY - read before refactoring this file.
//
// The wrappers do NOT agree on what they return on success:
//
//   getApiWithAuth / postApiWithAuth / patchApiWithAuth / putApiWithAuth
//       -> result.data   (the response BODY)
//   getApiWithoutAuth / postApiWithoutAuth / putApiWithoutAuth
//   updateApiWithAuth / deleteApiWithAuth
//       -> result        (the whole AXIOS RESPONSE, body nested under .data)
//
// So callers of the first group read `response.games`, and callers of the
// second read `response.data.games`. Both spellings are correct today, for
// different wrappers. Normalising them looks like a one-line cleanup and is
// not: it silently breaks every call site of whichever group you change, and
// the failures are empty lists rather than exceptions, so tests and manual
// clicking may not catch them. If you unify these, audit every consumer in
// utils/service.js in the same change.
//
// The error path is uniform - see apiError below.
// ---------------------------------------------------------------------------

// Every wrapper funnels failures through here. The contract:
//   - the response body is spread onto the result, so existing callers that
//     read `response.message` / `response.success` off a 4xx body keep working
//     (the join flow depends on this for "Insufficient Funds!");
//   - `__apiError` marks it as a failure, which is the ONLY reliable way to
//     tell a failed request from an empty result - a 500 body is truthy and
//     passes `if (response)` just like real data. Test it with isApiError()
//     from helpers/genericFunctions.
//   - `__status` is 0 when the request never got a response at all (network
//     down, CORS, timeout), where error.response is undefined.
// The double-underscore names cannot collide with a real payload field.
const apiError = (error) => {
  const body = error?.response?.data;
  const base =
    body && typeof body === "object" && !Array.isArray(body) ? body : {};
  return {
    ...base,
    __apiError: true,
    __status: error?.response?.status ?? 0,
    __body: body,
  };
};

const token = Cookies.get("user_token");
const backEndURLWithAuth = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `${token}`,
  },
});

const backEndURLWithoutAuth = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
export const postApiWithoutAuth = async (url, body) => {
  try {
    const result = await backEndURLWithoutAuth.post(url, body);
    return result;
  } catch (error) {
    return apiError(error);
  }
};
export const getApiWithoutAuth = async (url) => {
  try {
    const result = await backEndURLWithoutAuth.get(url);
    return result;
  } catch (error) {
    return apiError(error);
  }
};
export const putApiWithoutAuth = async (url, body) => {
  try {
    const result = await backEndURLWithoutAuth.put(url, body);
    return result;
  } catch (error) {
    return apiError(error);
  }
};
export const putApiWithAuth = async (url, body) => {
  backEndURLWithAuth.interceptors.request.use((config) => {
    // let token = getToken("access_token");
    let token = Cookies.get("user_token");
    config.headers["Authorization"] = "Bearer " + token;
    return config;
  });
  try {
    const result = await backEndURLWithAuth.put(url, body);
    return result.data;
  } catch (error) {
    return apiError(error);
  }
};

export const updateApiWithAuth = async (url, body) => {
  backEndURLWithAuth.interceptors.request.use((config) => {
    return config;
  });
  try {
    const result = await backEndURLWithAuth.patch(url, body);
    return result;
  } catch (error) {
    return apiError(error);
  }
};
export const deleteApiWithAuth = async (url) => {
  backEndURLWithAuth.interceptors.request.use((config) => {
    // let token = getToken("access_token");
    let token = Cookies.get("user_token");
    config.headers["Authorization"] = "Bearer " + token;
    return config;
  });
  try {
    const result = await backEndURLWithAuth.delete(url);
    return result;
  } catch (error) {
    return apiError(error);
  }
};

export const getApiWithAuth = async (url) => {
  backEndURLWithAuth.interceptors.request.use((config) => {
    // let token = getToken("loginToken");
    let token = Cookies.get("user_token");
    config.headers["Authorization"] = token;
    return config;
  });
  try {
    const result = await backEndURLWithAuth.get(url);
    return result.data;
  } catch (error) {
    // if (error?.response?.status == 401) {
    //   window.location.href = "/login";
    // }
    return apiError(error);
  }
};

export const postApiWithAuth = async (url, body) => {
  backEndURLWithAuth.interceptors.request.use((config) => {
    // let token = getToken("access_token");
    let token = Cookies.get("user_token");
    config.headers["Authorization"] = "Bearer " + token;
    return config;
  });
  try {
    const result = await backEndURLWithAuth.post(url, body);
    return result.data;
  } catch (error) {
    return apiError(error);
  }
};

export const patchApiWithAuth = async (url, body) => {
  backEndURLWithAuth.interceptors.request.use((config) => {
    // let token = getToken("access_token");
    let token = Cookies.get("user_token");
    config.headers["Authorization"] = "Bearer " + token;
    return config;
  });
  try {
    const result = await backEndURLWithAuth.patch(url, body);
    return result.data;
  } catch (error) {
    return apiError(error);
  }
};
